import { Button, DatePicker, Form, Input, Modal, Select } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { loadAllDesignation } from "../../../redux/rtk/features/designation/designationSlice";
import { loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";
import { addDepartmentHistory, getDepartments } from "../../department/departmentApis";


const DepartmentAddSinglePopup = ({ list, setLoading, initialData }) => {
  const [form] = Form.useForm();
const [departments, setDepartments] = useState([]);

useEffect(() => {
  getDepartments()
    .then((d) => {
      // console.log("Fetched departments:", d);
      setDepartments(d); // correctly set the department list
    })
    // .catch((error) => // console.log("Error fetching departments:", error));
}, []);


  // Use designations from Redux store
  const designations = useSelector((state) => state.designations.list);

  const { id } = useParams();
  const employeeId = Number(id);
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [DepartmentId, setDepartmentId] = useState(initialData?.DepartmentId || "");
  const [EffectedFrom, setEffectedFrom] = useState(
    initialData?.EffectedFrom ? dayjs(initialData.EffectedFrom) : null
  );
  const [EffectedTo, setEffectedTo] = useState(
    initialData?.EffectedTo ? dayjs(initialData.EffectedTo) : null
  );

  useEffect(() => {
    dispatch(loadAllDesignation());
    if (initialData) {
      form.setFieldsValue({
        DepartmentId: initialData.DepartmentId,
        EffectedFrom: initialData.EffectedFrom ? dayjs(initialData.EffectedFrom) : null,
        EffectedTo: initialData.EffectedTo ? dayjs(initialData.EffectedTo) : null,
      });
      setIsModalOpen(true); // Auto-open modal if initialData is provided
    }
  }, [dispatch, initialData, form]);

  const onFinish = async (values) => {
    if (!employeeId) {
      toast.error("Employee ID is missing. Please open the employee profile again.");
      setLoader(false);
      setLoading(false);
      return;
    }

    setLoader(true);
    setLoading(true);
    const infodata = {
      ...values,
      DepartmentHistoryId: 0,
      EmployeeId: employeeId,
      DepartmentId: parseInt(DepartmentId, 10),
      EffectedFrom: EffectedFrom ? dayjs(EffectedFrom).format("YYYY-MM-DD") : null,
      EffectedTo: EffectedTo ? dayjs(EffectedTo).format("YYYY-MM-DD") : null,
      DataStatus: 1,
    };

    const resp = await addDepartmentHistory(infodata);
    if (resp.message === "success") {
      setLoader(false);
      dispatch(loadSingleStaff(employeeId));
      setIsModalOpen(false);
      setLoading(false);
      form.resetFields();
    } else {
      setLoader(false);
      setLoading(false);
      toast.error(resp.message || "Failed to add designation");
    }
  };

  const onFinishFailed = (errorInfo) => {
    toast.warning("Failed at adding designation");
    setLoader(false);
    setLoading(false);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setEffectedFrom(null);
    setEffectedTo(null);
    setIsModalOpen(false);
    setLoader(false);
    setLoading(false);
    form.resetFields();
  };

  const handleCancel = () => {
    setEffectedFrom(null);
    setEffectedTo(null);
    setIsModalOpen(false);
    setLoader(false);
    setLoading(false);
    form.resetFields();
  };

  return (
    <>
      <div className="text-center">
        <Button type="primary" onClick={showModal}>
          Add New Department
        </Button>
      </div>
      <Modal
        title={`Add Department`}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form
          form={form}
          style={{ marginBottom: "100px" }}
          eventKey="department-form"
          name="basic"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 16 }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <div>
           <Form.Item
                            style={{ marginBottom: "10px" }}
                            label="Department"
                            name="DepartmentId"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input your Designation!",
                                },
                            ]}
                        >
                            <Select
                                placeholder="Select Department"
                                onChange={(value) => setDepartmentId(value)}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {departments?.map((item) => (
                                    <Select.Option key={item.DepartmentId} value={item.DepartmentId}>
                                        {item.DepartmentName || ""}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>


            <Form.Item
              style={{ marginBottom: "10px" }}
              label="Effected From"
              name="EffectedFrom"
              rules={[{ required: true, message: "Please input your start date!" }]}
            >
              <DatePicker onChange={(date) => setEffectedFrom(date)} />
            </Form.Item>

            <Form.Item
              style={{ marginBottom: "10px" }}
              label="Effected To"
              name="EffectedTo"
            >
              <DatePicker onChange={(date) => setEffectedTo(date)} />
            </Form.Item>

            <Form.Item
              style={{ marginBottom: "20px" }}
              wrapperCol={{ offset: 6, span: 12 }}
            >
              <Button
                onClick={() => setLoader(true)}
                type="primary"
                size="small"
                htmlType="submit"
                block
                loading={loader}
              >
                Add Now
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default DepartmentAddSinglePopup;